export default "__VITE_ASSET__af802d58__"